import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { Checkbox } from 'primereact/checkbox';
import { injectIntl } from 'react-intl';
import { TOGGLE_ALLOW_GLOBAL_FIELDS_QUESTIONNAIRE } from '../mutations';
import messages from '../intl-messages';
import { withGrowl } from '../../../../components/GrowlNotifications';
import { Loading } from '../../../../components/Loading';

const ManageAllowUseForQuestionnaires = ({
  currentAccount, data, intl: { formatMessage }, growl,
}) => {
  const [useForQuestionnaireAllowed, setUseForQuestionnaireAllowed] = useState(false);

  const [toggleAllowUseForQuestionnaire, toggleAllowUseForQuestionnaireResult] = useMutation(
    TOGGLE_ALLOW_GLOBAL_FIELDS_QUESTIONNAIRE, { refetchQueries: ['getAccount'] },
  );

  useEffect(() => {
    setUseForQuestionnaireAllowed(data.account.globalAriFieldsEnabledForQuestionnaires);
  }, [data]);

  return (
    <div className="p-grid p-align-center" style={{ borderBottom: '1px dashed black' }}>
      <div className="p-col-12">
        <small>
          {formatMessage(messages.allowFieldUseForQuestionnaires)}
        </small>

        <label htmlFor="cb-q" className="p-checkbox-label">
          {useForQuestionnaireAllowed
            ? formatMessage(messages.allowLocalFieldUseYesLabel)
            : formatMessage(messages.allowLocalFieldUseNoLabel)}
        </label>

        {toggleAllowUseForQuestionnaire.loading ? (<Loading />)
          : (
            <Checkbox
              style={{ marginLeft: '5px' }}
              inputId="cb-q"
              disabled={toggleAllowUseForQuestionnaireResult.loading}
              checked={useForQuestionnaireAllowed}
              onChange={() => {
                const input = {
                  accountId: currentAccount,
                  canUseAriFields: !useForQuestionnaireAllowed,
                };
                setUseForQuestionnaireAllowed(!useForQuestionnaireAllowed);
                toggleAllowUseForQuestionnaire({ variables: { input } })
                  .then(() => {
                    growl.show({
                      severity: 'success',
                      summary: formatMessage(messages.growlToggleUseInQuestionnairesSuccessSummary),
                      detail: formatMessage(messages.growlToggleUseInQuestionnairesSuccessDetail),
                      sticky: false,
                    });
                  })
                  .catch(() => {
                    setUseForQuestionnaireAllowed(useForQuestionnaireAllowed);
                    growl.show({
                      severity: 'error',
                      summary: formatMessage(messages.growlToggleAllowSubaccountsFieldUseSummary),
                      detail: formatMessage(messages.growlToggleAllowSubaccountsFieldUseFail),
                      sticky: true,
                    });
                  });
              }}
            />
          )}
      </div>
    </div>
  );
};

ManageAllowUseForQuestionnaires.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  growl: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withGrowl(injectIntl(ManageAllowUseForQuestionnaires));
